import type { IData } from "~/interfaces";
import { getThemeData } from "~/utils";

const data: IData = getThemeData();
export default defineNuxtPlugin(() => {
  return {
    provide: {
      login: async (code: string) => {
        const envType = getStateValue("envType");
        const envName = getStateValue("envName");
        const url = `${data.endpoints.server}access_code/${code}`;

        if (isDev()) {
          updateStateValue("protected", false);
        }

        try {
          const resp = (await $fetch(url, {
            method: "POST",
            body: { envType, envName },
          })) as { success: boolean };

          if (resp.success) {
            if (getStateValue("loginError")) {
              updateStateValue("loginError", null);
            }
            updateStateValue("protected", false);
            return;
          }

          updateStateValue(
            "loginError",
            "ATTENZIONE! Il codice inserito non è valido",
          );
        } catch (error) {
          console.error("Login error:", error);
        }
      },
    },
  };
});
